export const SET_ENUMS_DATA = '@enums/set-enums-data';

export function setEnumsData(data) {
  return (dispatch) => dispatch({
    type: SET_ENUMS_DATA,
    payload: data
  });
}
